import MosaiqClient from "../clients/MosaiqClient";
import {
  BestSellers,
  Featured,
  MarketingCategory,
  MarketingHome,
  Seo,
  Sliders,
  Universe,
} from "@/models/marketingHome";
import axios, { AxiosRequestConfig } from "axios";
import { i18n } from "vue-lang-router";
export default class MarketingService {

  private cancelCatgoryMarketing;


  static of(): MarketingService {
    return new MarketingService();
  }

  getFaq() {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        attrRef: "sku",
      },
    };
    return MosaiqClient.of().get("products/marketing/faq", axiosRequestConfig).then(
      (data) => {
        return data.values;
      },
      err => {
        throw err;
      },
    );
  }

  getCategory(categoryPath) {
    /*
    *  "attrId":"marketing_landing_category",
            "attrValue": "/ART DE VIVRE/ARTS DE VIVRE/",
            "section": "...",
            * */
    const params = {
      attrId: "landing_page_category",
      attrValue: categoryPath,
      categoryUp: false,
    };
    if (typeof this.cancelCatgoryMarketing != typeof undefined) {
      this.cancelCatgoryMarketing.cancel({ cancel: true });
    }

    this.cancelCatgoryMarketing = axios.CancelToken.source();

    return MosaiqClient.of().post("products/landing_pages/findOne", params,  {cancelToken: this.cancelCatgoryMarketing.token}).then(
      (data) => {
        return MarketingCategory.of(data.values);
      },
      err => {
        throw err;
      },
    );
  }

  getHomePage(section) {
    /*
    marketing_homepage_slider
    marketing_homepage_bestsellers
    marketing_homepage_featured
    marketing_homepage_universe
    marketing_homepage_seo
    */

    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        section: section,
        attrRef: "sku",
      },
    };

    return MosaiqClient.of().get("products/marketing/homepage", axiosRequestConfig).then(
      (data) => {

        return MarketingHome.of(data.values);
      },
      err => {
        throw err;
      },
    );
  }

  getHomeFeatured() {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        section: "homepage_featured",
        attrRef: "sku",
      },
    };
    return MosaiqClient.of().get("products/marketing/homepage", axiosRequestConfig).then(
      (data) => {
        return Featured.of(data.values);
      },
      err => {
        throw err;
      },
    );
  }

  getHomeSlider() {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        section: "homepage_slider",
        attrRef: "sku",
      },
    };
    return MosaiqClient.of().get("products/marketing/homepage", axiosRequestConfig).then(
      (data) => {
        return Sliders.of(data.values);
      },
      err => {
        throw err;
      },
    );
  }

  getBestSellers() {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        section: "homepage_bestsellers",
        attrRef: "sku",
        replaceIdBy: "sku",
      },
    };
    return MosaiqClient.of().get("products/marketing/homepage", axiosRequestConfig).then(
      (data) => {
        return BestSellers.of(data.values);
      },
      err => {
        throw err;
      },
    );
  }

  getUniverse() {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        section: "universe",
        attrRef: "sku",
      },
    };
    return MosaiqClient.of().get("products/marketing/homepage", axiosRequestConfig).then(
      (data) => {
        return Universe.of(data.values);
      },
      err => {
        throw err;
      },
    );
  }
  getContentPage(pageId) {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        attrRef: "sku",
      },
    };
    return MosaiqClient.of().get("products/marketing/"+pageId, axiosRequestConfig).then(
        (data) => {
          return data.values;
        },
        err => {
          throw err;
        },
    );
  }
  setSeo(content){

    const descEl = document.querySelector('head meta[name="description"]');
    const titleEl = document.querySelector('head title');
    if(descEl)
      descEl.setAttribute('content', content.cms_seo_description?content.cms_seo_description:i18n.t('seo.defaultDescription'));
    if(titleEl)
      titleEl.textContent = content.cms_seo_title ? content.cms_seo_title : i18n.t('seo.defaultPageTitle', {pageName: content.cms_title});
  }

  getHomeSeo() {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        section: "cms_seo",
        attrRef: "sku",
      },
    };
    return MosaiqClient.of().get("products/marketing/homepage", axiosRequestConfig).then(
      (data) => {
        return Seo.of(data.values);
      },
      err => {
        throw err;
      },
    );
  }

  getDelivery() {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        attrRef: "sku",
      },
    };
    return MosaiqClient.of().get("products/marketing/delivery", axiosRequestConfig).then(
      (data) => {
        return data.values;
      },
      err => {
        throw err;
      },
    );
  }



  getEchangeAndReturn() {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        attrRef: "sku",
      },
    };
    return MosaiqClient.of().get("products/marketing/exchange_return", axiosRequestConfig).then(
      (data) => {
        return data.values;
      },
      err => {
        throw err;
      },
    );
  }

  getCGV() { /* TODO */
  }

}